<template>
  <b-form-row>
    <b-col cols="12">
      <b-form-checkbox v-model="model.render">
        Render
      </b-form-checkbox>
    </b-col>
    <b-col cols="6">
      <label class="mb-1 small">Left Top</label>
      <b-form-group
        label="X"
        label-cols-sm="2"
        class="mb-1"
        label-size="sm"
      >
        <b-input
          :value="tl[0].toFixed(2)"
          type="number"
          size="sm"
          class="form-control-sm"
          @input="onChangeCoords('tl', 0, $event)"
        />
      </b-form-group>
      <b-form-group
        label="Y"
        label-cols-sm="2"
        class="mb-1"
        label-size="sm"
      >
        <b-input
          :value="tl[1].toFixed(2)"
          type="number"
          size="sm"
          class="form-control-sm"
          @input="onChangeCoords('tl', 1, $event)"
        />
      </b-form-group>
    </b-col>
    <b-col cols="6">
      <label class="mb-1 small">Right Top</label>
      <b-form-group
        label="X"
        label-cols-sm="2"
        class="mb-1"
        label-size="sm"
      >
        <b-input
          :value="tr[0].toFixed(2)"
          type="number"
          size="sm"
          class="form-control-sm"
          @input="onChangeCoords('tr', 0, $event)"
        />
      </b-form-group>
      <b-form-group
        label="Y"
        label-cols-sm="2"
        class="mb-1"
        label-size="sm"
      >
        <b-input
          :value="tr[1].toFixed(2)"
          type="number"
          size="sm"
          class="form-control-sm"
          @input="onChangeCoords('tr', 1, $event)"
        />
      </b-form-group>
    </b-col>
    <b-col cols="6">
      <label class="mb-1 small">Bottom Left</label>
      <b-form-group
        label="X"
        label-cols-sm="2"
        class="mb-1"
        label-size="sm"
      >
        <b-input
          :value="bl[0].toFixed(2)"
          type="number"
          size="sm"
          class="form-control-sm"
          @input="onChangeCoords('bl', 0, $event)"
        />
      </b-form-group>
      <b-form-group
        label="Y"
        label-cols-sm="2"
        class="mb-1"
        label-size="sm"
      >
        <b-input
          :value="bl[1].toFixed(2)"
          type="number"
          size="sm"
          class="form-control-sm"
          @input="onChangeCoords('bl', 1, $event)"
        />
      </b-form-group>
    </b-col>
    <b-col cols="6">
      <label class="mb-1 small">Bottom Right</label>
      <b-form-group
        label="X"
        label-cols-sm="2"
        class="mb-1"
        label-size="sm"
      >
        <b-input
          :value="br[0].toFixed(2)"
          type="number"
          size="sm"
          class="form-control-sm"
          @input="onChangeCoords('br', 0, $event)"
        />
      </b-form-group>
      <b-form-group
        label="Y"
        label-cols-sm="2"
        class="mb-1"
        label-size="sm"
      >
        <b-input
          :value="br[1].toFixed(2)"
          type="number"
          size="sm"
          class="form-control-sm"
          @input="onChangeCoords('br', 1, $event)"
        />
      </b-form-group>
    </b-col>
  </b-form-row>
</template>


<script>
import mixinInput from "@frontend/components/input-mixins";

export default {
  name: 'SkewForm',
  mixins: [mixinInput],
  props: {
    tl: {type: Array, required: true},
    tr: {type: Array, required: true},
    br: {type: Array, required: true},
    bl: {type: Array, required: true},
    isRender: { type: Boolean, default: false }
  },
  emits: ['change'],
  data() {
    return {
      model: {
        value: {
          tl: [...this.tl],
          tr: [...this.tr],
          br: [...this.br],
          bl: [...this.bl],
        },
        render: this.isRender
      }
    };
  },
  computed: {
    computedModel() {
      return Object.assign({}, this.model)
    }
  },
  watch: {
    tl(val) {
      this.model.value.tl = [...val];
    },
    tr(val) {
      this.model.value.tr = [...val];
    },
    br(val) {
      this.model.value.br = [...val];
    },
    bl(val) {
      this.model.value.bl = [...val];
    },
    isRender(val) {
      this.model.render = val;
    },
    computedModel: {
      handler(val, prevVal) {
        if (_.isEqual(val, prevVal)) {
          return;
        }
        this.$emit('change', {
          value: [
            this.computedModel.value.tl,
            this.computedModel.value.tr,
            this.computedModel.value.br,
            this.computedModel.value.bl,
          ].flat(),
          render: this.computedModel.render
        });
      },
      deep: true
    }
  },
  methods: {
    onChangeCoords: _.debounce(function (point, index, val) {
      const parsed = parseFloat(val);
      const value = isNaN(parsed) ? 0 : parsed;

      const updated = {
        tl: [...this.model.value.tl],
        tr: [...this.model.value.tr],
        br: [...this.model.value.br],
        bl: [...this.model.value.bl],
      };

      updated[point][index] = value;

      this.model.value = updated;
    }, 300)
  }
}
</script>

<style>

</style>
